import ApiClient from './ApiClient';

class EmpresaNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.empresaId = null;
  }

  get url() {
    return `${this.baseUrl()}/empresas/${this.empresaId}/notes`;
  }

  get(empresaId) {
    this.empresaId = empresaId;
    return super.get();
  }

  create(empresaId, content) {
    this.empresaId = empresaId;
    return super.create({ content });
  }

  delete(empresaId, id) {
    this.empresaId = empresaId;
    return super.delete(id);
  }
}

export default new EmpresaNotes();
